// routes
// import { paths } from 'src/routes/paths';
// utils
import axiosInstance from 'src/utils/axios_ballcharts';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {

  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const

  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 1000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime; // * 1000 is from seconds to milliseconds
  // console.log('timeLeft in setSession', timeLeft);

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Your session has expired.  You are being logged out.');

    localStorage.removeItem('accessToken');
    
    // CHECKING FOR AUTHENTICATION HERE, may need to re-enable this
    window.location.href = window.location.pathname;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    // console.log('exp in setSession', exp);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');

    delete axiosInstance.defaults.headers.common.Authorization;
  }
};
